import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Box, Typography, CircularProgress, alpha, useTheme } from '@mui/material';
import MusicPlayer from './MusicPlayer';
import axiosInstance from '../api/axiosConfig';

const backendUrl = process.env.REACT_APP_BACKEND_URL || '';

const PlaylistDetail: React.FC = () => {
  const { pid } = useParams();
  const [playlist, setPlaylist] = useState<any>(null);
  const [index, setIndex] = useState<number>(0);
  const theme = useTheme();

  const fetchPlaylist = useCallback(async () => {
    if (!pid) return;
    try {
      const resp = await axiosInstance.get(`${backendUrl}/api/playlists/${pid}`);
      setPlaylist(resp.data);
      setIndex(0);
    } catch (e) {
      console.error(e);
    }
  }, [pid]);

  useEffect(() => { fetchPlaylist(); }, [fetchPlaylist]);

  const removeVideo = async (vid: string) => {
    if (!pid) return;
    try {
      await axiosInstance.delete(`${backendUrl}/api/playlists/${pid}/videos/${vid}`);
      await fetchPlaylist();
    } catch (e) {
      console.error(e);
    }
  };

  if (!playlist) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth={false} sx={{ mt: 2, mb: 4, px: { xs: 0, sm: 2 } }}>
      <Box sx={{ 
        mb: 3, 
        p: 3, 
        // bgcolor: alpha(theme.palette.background.paper, 0.8),
        bgcolor: 'transparent',
        // backdropFilter: 'blur(20px)',
        // border: '1px solid rgba(255,255,255,0.1)',
        // borderRadius: 3,

        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
      }}>
        <Typography variant="h6" sx={{ fontWeight: 400, mb: 1 }}>
          {playlist.name}
        </Typography>
        {/* {playlist.description && (
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600 }}>
            {playlist.description}
          </Typography>
        )}
        <Typography variant="caption" sx={{ mt: 1, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 1 }}>
          {playlist.videos?.length || 0} Videos
        </Typography> */}
      </Box>

      {playlist.videos && playlist.videos.length > 0 ? (
        <MusicPlayer 
          playlist={playlist.videos} 
          startIndex={index} 
          playlistId={pid || ''}
          onRemove={async (vid: string) => { await removeVideo(vid); }} 
        />
      ) : (
        <Box sx={{ 
          p: 8, 
          textAlign: 'center', 
          border: '2px dashed rgba(255,255,255,0.1)', 
          borderRadius: 4,
          bgcolor: alpha(theme.palette.background.paper, 0.2)
        }}>
          <Typography variant="h6" color="text.secondary">
            This playlist is empty
          </Typography>
          <Typography variant="body2" color="text.disabled" sx={{ mt: 1 }}>
            Add videos from the main library using the "Select" mode.
          </Typography>
        </Box>
      )}
    </Container>
  );
};

export default PlaylistDetail;
